import { render, staticRenderFns } from "./GithubLink.vue?vue&type=template&id=4a69e518&"
import script from "./GithubLink.vue?vue&type=script&lang=js&"
export * from "./GithubLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports